import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useAuthContext } from "src/auth/useAuthContext";
import { useParams } from "react-router-dom";
// @mui
import { Box, Container, Tab, Tabs } from "@mui/material";
// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
import CustomBreadcrumbs from "../../../components/custom-breadcrumbs";
import Iconify from "../../../components/iconify";
import { useSettingsContext } from "../../../components/settings";
import CustomerOrderListPage from "./customerOrders/CustomerOrderListPage";
import CustomerGeneralInfo from "./CutomerGeneralInfo";
import { getCustomers } from "src/redux/slices/customer";
import CustomerReservationListPage from "./customerReservations/CustomerReservationListPage";
import CustomerReviewsListPage from "./customerReviews/CustomerReviewsListPage";
import CustomerStatsDemo from "./CustomerStatsDemo";
// ----------------------------------------------------------------------

export default function CustomerInfoPage() {
  const { id } = useParams();
  const { customers } = useSelector((state) => state.customer);

  let dispatch = useDispatch();
  const { user } = useAuthContext();

  useEffect(() => {
    dispatch(getCustomers(user.venue.id));
  }, [dispatch, user.venue.id]);

  const { themeStretch } = useSettingsContext();

  const customer = customers.find((customer) => customer.id === id);

  const TABS = [
    {
      value: "general",
      label: "General",
      icon: <Iconify icon="ic:round-account-box" />,
      component: <CustomerGeneralInfo customer={customer} />,
    },
    {
      value: "liveStock",
      label: "Stats",
      icon: <Iconify icon="ic:round-account-box" />,
      component: <CustomerStatsDemo phone={customer?.phone} customer={customer}  />,
    },

    {
      value: "orders",
      label: "Orders",
      icon: <Iconify icon="ic:round-receipt" />,
      component: <CustomerOrderListPage phone={customer?.phone} />,
    },

    // {
    //   value: "reviews",
    //   label: "Reviews",
    //   icon: <Iconify icon="ic:round-receipt" />,
    //   component: (
    //     <CustomerReviewsListPage phone={customer?.phone} />
    //   ),
    // },
  ].filter(Boolean);

  if (user?.venue?.configurations?.isReservation) {
    TABS.push({
      value: "reservations",
      label: "Reservations",
      icon: <Iconify icon="ic:round-view-module" />,
      component: <CustomerReservationListPage phone={customer?.phone} />,
    });
  }

  const [currentTab, setCurrentTab] = useState(TABS[0]?.value);

  return (
    <>
      <Helmet>
        <title> Customer: Customer | Venue - Egora</title>
      </Helmet>
      <Container maxWidth={themeStretch ? false : 'xxl'}>
        <CustomBreadcrumbs
          heading="Customer Info"
          links={[
            { name: "Dashboard", href: PATH_DASHBOARD.root },
            { name: "Customer", href: PATH_DASHBOARD.customer.list },
            {
              name: customer?.firstName,
            },
          ]}
        />

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Tabs
            value={currentTab}
            onChange={(event, newValue) => setCurrentTab(newValue)}
          >
            {TABS.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                icon={tab.icon}
                value={tab.value}
              />
            ))}
          </Tabs>
        </Box>

        {TABS.map(
          (tab) =>
            tab.value === currentTab && (
              <Box key={tab.value} sx={{ mt: 5 }}>
                {tab.component}
              </Box>
            )
        )}
      </Container>
    </>
  );
}
